<desy-card
  classes="w-1/3"
  [containerClasses]="
    'p-base border-2 mb-4 w-[1200px] lg:min-w-0 custom-card-width border-neutral-light !m-0 !border !border-neutral-500 rounded-[4px]'
  ">
  <div class="text-ms flex flex-col my-2">
    <div class="flex w-[1200px] py-2 px-4 items-end gap-2">
      <h3 class="text-[18px] font-bold flex-1">
        {{ projectName }}
      </h3>
      <div class="flex gap-4 mr-8">
        @for (button of buttons; track $index) {
          @if (button.url) {
            <a
              [attr.href]="button.disabled ? null : button.url"
              [attr.title]="button.disabled ? button.title : null">
              <app-buttons
                [classes]="button.buttonClass || 'c-button--sm'"
                [disabled]="button.disabled ?? false"
                [label]="button.label ?? ''" />
            </a>
          } @else {
            <app-buttons
              [classes]="button.buttonClass || 'c-button--sm'"
              [disabled]="button.disabled ?? false"
              [clickEvent]="button.disabled ? undefined : button.action"
              [label]="button.label ?? ''" />
          }
        }
      </div>
    </div>

    <div class="flex gap-2 w-full min-w-full justify-start items-center pb-2 px-4 mt-4">
      <div
        *ngIf="stateText"
        class="w-3 h-3 color rounded-sm"
        [ngClass]="color"></div>
      <span
        *ngIf="stateText"
        class="font-normal">
        {{ stateText }}
      </span>
      <span class="text-[16px] text-neutral-dark">
        Creado por {{ creationUser }} el día {{ creationDate ? (creationDate | spanishDate) : '' }}
      </span>
    </div>

    <div class="border-t md:w-[1150px] border-neutral-300"></div>

    <div
      class="grid grid-cols-1 gap-3 mt-4 px-4 w-full"
      [ngClass]="dataPerRowMdClass">
      <ng-container *ngFor="let info of infoCard; let i = index">
        <div class="flex flex-col">
          <span class="text-neutral-dark font-regular text-[14px]">{{ info.label }}</span>
          @if (typeof info.value === 'string') {
            @if (
              info.value === 'minimo' ||
              info.value === 'limitado' ||
              info.value === 'alto' ||
              info.value === 'inaceptable'
            ) {
              <span
                class="text-md font-semibold"
                [ngClass]="info.value | riskLevelClass">
                {{ riskLevelLabel(info.value) }}
              </span>
            } @else {
              <span class="font-normal text-black text-[16px]">{{ info.value }}</span>
            }
          } @else {
            @if (info.value !== null) {
              <desy-tooltip id="tooltip1">
                <desy-content>
                  <span>Total {{ info.value?.length }}</span>
                </desy-content>
                <desy-icon type="info"></desy-icon>
                <desy-tooltip-content>
                  <ul
                    class="list-none"
                    *ngFor="let item of info.value; let i = index">
                    <li>{{ item }}</li>
                  </ul>
                </desy-tooltip-content>
              </desy-tooltip>
            } @else {
              <span class="font-semibold text-black text-sm">No disponible</span>
            }
          }
        </div>
      </ng-container>
    </div>

    <div
      *ngIf="description"
      class="mt-4 px-4">
      <desy-details
        classes="pr-6"
        summaryText="Mostrar descripción">
        {{ description }}
      </desy-details>
    </div>
  </div>
</desy-card>
